/* eslint-disable no-unused-vars */
import { Col, Row, Form, Checkbox } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import extraSettings from '../../../assets/images/extraSettings.svg';
import storeOpenClose from '../../../assets/images/storeOpenClose.svg';
import { DokanButtons } from '../../../components/button/DokanButtons';
import DokanCard from '../../../components/card/DokanCard';
import DokanCollapsableCard from '../../../components/card/DokanCollapsableCard';
import DokanDropZone from '../../../components/DokanDropZone';
import DokanCheckBox from '../../../components/form/DokanCheckBox';
import DokanSelectField from '../../../components/form/DokanSelectField';
import DokanSwitchButton from '../../../components/form/DokanSwitchButton';
import DokanTextAreaField from '../../../components/form/DokanTextAreaField';
import DokanTextInputField from '../../../components/form/DokanTextInputField';
import DokanTinyEditor from '../../../components/form/DokanTinyEditor';
import DokanGoogleMaps from '../../../components/map/DokanGoogleMaps';
import StoreGeneral from '../../../components/store/General';
import DokanPageTitle from '../../../components/text/DokanPageTitle';
import DokanSettingsFieldLabel from '../../../components/text/DokanSettingsFieldLabel';
import { fetchSettings, handleStoreSettingsInput } from '../../../redux/settings/settingsActions';

const Store = () => {
    const [isSupportChecked, setIsSupportChecked] = useState(true);
    const [isNotifyChecked, setIsNotifyChecked] = useState(false);
    /** -------- API Calling Area ---- */
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchSettings());
    }, [dispatch]);

    const { settings } = useSelector((state) => state.settings);

    /** -------- API Calling End ---- */
    const handleChange = () => {
        setIsSupportChecked(!isSupportChecked);
        setIsNotifyChecked(!isNotifyChecked);
    };

    // Form Handling....
    const onFinish = (values) => {
        console.log(values);
    };
    const onFinishFailed = (errorInfo) => {
        console.log(errorInfo);
    };

    const handleChangeInput = (name, value = '', e = null) => {
        dispatch(handleStoreSettingsInput(name, value, e));
    };

    const handleDefaultChecked = (day) => day.status === 'open';
    return (
        <>
            <Form
                name="store"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <div className="container mx-auto">
                    <div className="flex justify-between flex-col gap-5 md:flex-row p-35px">
                        <div>
                            <DokanPageTitle>Visit Store</DokanPageTitle>
                        </div>
                        <div className="flex">
                            <DokanButtons
                                variant="white"
                                btnText="text-dark"
                                buttonStyle="md:ml-20px py-15px bg-white"
                            >
                                Reset
                            </DokanButtons>

                            <button
                                type="submit"
                                className="ml-20px py-15px px-20px text-white rounded-sm focus:outline-none text-sm font-normal bg-button-secondary"
                            >
                                Update Settings
                            </button>
                        </div>
                    </div>
                    <div className="px-25px md:pl-70px md:pr-35px">
                        <div className="grid grid-flow-row gap-5">
                            <div>
                                <DokanCard disableMargin>
                                    <DokanDropZone />

                                    <StoreGeneral
                                        store={settings}
                                        onInputChange={handleChangeInput}
                                    />

                                    <DokanSettingsFieldLabel>Maps</DokanSettingsFieldLabel>
                                    <DokanTextInputField placeholder="Mirpur DOHS Dhaka" />
                                    <DokanGoogleMaps />

                                    <DokanSettingsFieldLabel>Biography</DokanSettingsFieldLabel>
                                    <DokanTinyEditor
                                        setHeight="100px"
                                        FormInputName="biography"
                                        onValueChange={handleChangeInput}
                                    />
                                </DokanCard>
                            </div>
                            <div>
                                <DokanCollapsableCard
                                    disableMargin
                                    cardTitle="Store Opening & Closing"
                                    hasIcon={storeOpenClose}
                                >
                                    <DokanSettingsFieldLabel>
                                        Store Opening Closing Time
                                    </DokanSettingsFieldLabel>
                                    <Checkbox className="mt-25px mb-2 dokan-checkbox">
                                        <span className="text-sm font-light">
                                            Show store opening clossing time widget in store page{' '}
                                        </span>
                                    </Checkbox>
                                    {settings.dokan_store_time && (
                                        <>
                                            <DokanSwitchButton
                                                label="Sunday"
                                                dokanStoreTime={settings.dokan_store_time?.sunday}
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.sunday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Monday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.monday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Tuesday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.tuesday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Wednesday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.wednesday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Thursday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.thursday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Friday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.friday
                                                    )
                                                }
                                            />
                                            <DokanSwitchButton
                                                label="Saturday"
                                                defaultChecked={() =>
                                                    handleDefaultChecked(
                                                        settings.dokan_store_time?.saturday
                                                    )
                                                }
                                            />
                                        </>
                                    )}

                                    <DokanSettingsFieldLabel>Notice</DokanSettingsFieldLabel>
                                    <DokanTextAreaField placeholder="Store Open Notice" />
                                    <DokanTextAreaField placeholder="Store Close Notice" />
                                </DokanCollapsableCard>
                            </div>
                            <div>
                                <DokanCollapsableCard
                                    disableMargin
                                    cardTitle="Extra Settings"
                                    hasIcon={extraSettings}
                                >
                                    <DokanSettingsFieldLabel>
                                        Show Product Per Page
                                    </DokanSettingsFieldLabel>
                                    <DokanTextInputField placeholder="10" />
                                    <DokanSettingsFieldLabel>More Products</DokanSettingsFieldLabel>
                                    <DokanCheckBox> Show email address in store</DokanCheckBox>
                                    <DokanSettingsFieldLabel>Enable Button</DokanSettingsFieldLabel>
                                    <Checkbox
                                        checked={isSupportChecked}
                                        className="mt-20px dokan-checkbox"
                                        onChange={handleChange}
                                    >
                                        <span className="text-sm font-light">
                                            Show Support Button
                                        </span>
                                    </Checkbox>
                                    <Checkbox
                                        checked={isNotifyChecked}
                                        className="mt-20px dokan-checkbox"
                                        onChange={handleChange}
                                    >
                                        <span className="text-sm font-light">
                                            Show Notify Button
                                        </span>
                                    </Checkbox>
                                    {isSupportChecked && (
                                        <DokanTextInputField placeholder="Get Support" />
                                    )}
                                    {isNotifyChecked && (
                                        <DokanTextInputField placeholder="Get Notified" />
                                    )}
                                    <DokanSettingsFieldLabel>
                                        Terms & Conditions
                                    </DokanSettingsFieldLabel>
                                    <DokanCheckBox>
                                        {' '}
                                        Show Terms & Conditions in Store Page
                                    </DokanCheckBox>
                                    <DokanTinyEditor
                                        setHeight="100px"
                                        FormInputName="terms_conditions"
                                        onValueChange={handleChangeInput}
                                    />
                                </DokanCollapsableCard>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-between flex-col gap-5 md:flex-row p-35px">
                        <div>&nbsp;</div>
                        <div className="flex">
                            <DokanButtons
                                variant="white"
                                btnText="text-dark"
                                buttonStyle="md:ml-20px py-15px bg-white"
                            >
                                Reset
                            </DokanButtons>

                            <button
                                type="submit"
                                className="ml-20px py-15px px-20px text-white rounded-sm focus:outline-none text-sm font-normal bg-button-secondary"
                            >
                                Update Settings
                            </button>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default Store;
